import React from 'react';

import { Container } from './styles';

const ModalBody: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};

export default ModalBody;
